import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard } from 'lucide-react'
import { useLanguage } from '../contexts/LanguageContext'

type DashboardButtonProps = {
  className?: string
  /** Keep the label at every width (headers with room to spare). */
  alwaysLabelled?: boolean
}

// "Dashboard" header control. The wordmark now goes to the public home page, so
// every signed-in screen needs its own explicit way back to the event list —
// this is it. Renders nothing on /dashboard itself, where it would be a link to
// the page you are already on.
const DashboardButton = ({ className = '', alwaysLabelled = false }: DashboardButtonProps) => {
  const { language } = useLanguage()
  const { pathname } = useLocation()
  if (pathname === '/dashboard') return null

  const label = language === 'ka' ? 'დაშბორდი' : 'Dashboard'

  return (
    <Link
      to="/dashboard"
      aria-label={label}
      data-testid="header-dashboard-btn"
      className={`inline-flex h-9 shrink-0 items-center gap-1.5 rounded-full border border-[#ff4d8d]/30 bg-[#ff4d8d]/[0.06] px-3 text-sm font-semibold text-[#ff4d8d] transition-colors hover:border-[#ff4d8d]/60 hover:bg-[#ff4d8d]/[0.12] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff4d8d]/40 ${className}`.trim()}
    >
      <LayoutDashboard className="h-4 w-4 shrink-0" />
      <span className={alwaysLabelled ? '' : 'hidden sm:inline'}>{label}</span>
    </Link>
  )
}

export default DashboardButton
